import { useCreateAutomationWithAgent } from "@/panes/automation/useCreateAutomationWithAgent";
import { useOpenAutomation } from "@/panes/automation/useOpenAutomation";
import { useCallback } from "react";

/**
 * The two create verbs for Automations — shared by the rail-head glyph menu
 * and the rail's closing ActionRow so every entry point offers the identical
 * pair: the manual pane form, or a seeded agent chat.
 */
export function useAutomationsRailCreateActions() {
  const openAutomation = useOpenAutomation();
  const { createWithAgent } = useCreateAutomationWithAgent();

  const openCreatePane = useCallback(() => {
    openAutomation("new");
  }, [openAutomation]);

  return { openCreatePane, createWithAgent };
}
